import { Box, capitalize } from "@mui/material";
import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";
import { USDollar } from "utils/helpers";

export const paymentColumns = [
  {
    label: "Date",
    field: "created",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ created }) => {
      if (!created) return null;
      const isUnixTime = typeof created === "number";
      const date = new Date(isUnixTime ? created * 1000 : created);
      return new Intl.DateTimeFormat("en-US", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(date);
    },
  },
  {
    label: "Invoice #",
    field: "invoiceId",
    xs: 1,
    sm: 1,
    md: 1,
    align: "center",
    renderer: ({ invoiceId }) => (
      <TextFieldWithEllipsis>{invoiceId}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Recipient",
    field: "name",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "phone",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ phone }) => (
      <TextFieldWithEllipsis>{phone}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Amount",
    field: "amount",
    xs: 2,
    sm: 2,
    md: 2,
    align: "center",
    renderer: ({ amount }) => (
      <Box sx={{ marginRight: "30%", textAlign: "right" }}>
        {USDollar.format(amount / 100)}
      </Box>
    ),
  },
  {
    label: "Payment",
    field: "paymentStatus",
    xs: 1,
    sm: 1,
    md: 1,
    align: "center",
    renderer: ({ status }) =>
      status === "succeeded" ? (
        <Box sx={{ color: "green" }}>{capitalize(status ?? "")}</Box>
      ) : (
        <Box sx={{ color: "red" }}>{capitalize(status ?? "")}</Box>
      ),
  },
];

export const mobilePaymentColumns = [
  {
    label: "Date",
    field: "invoice_date",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ created }) => {
      if (!created) return null;
      const isUnixTime = typeof created === "number";
      const date = new Date(isUnixTime ? created * 1000 : created);
      return new Intl.DateTimeFormat("en-US").format(date);
    },
  },
  {
    label: "Invoice #",
    field: "invoiceId",
    xs: 2,
    sm: 2,
    md: 2,
    align: "center",
    renderer: ({ invoiceId }) => (
      <TextFieldWithEllipsis>{invoiceId}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Recipient",
    field: "name",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Amount",
    field: "amount",
    xs: 3,
    sm: 3,
    md: 3,
    align: "center",
    renderer: ({ amount }) => (
      <Box sx={{ marginRight: "30%", textAlign: "right" }}>
        {USDollar.format(amount / 100)}
      </Box>
    ),
  },
  {
    label: "Payment",
    field: "paymentStatus",
    xs: 2,
    sm: 2,
    md: 2,
    align: "center",
    renderer: ({ status }) =>
      status === "succeeded" ? (
        <Box sx={{ color: "green" }}>{capitalize(status ?? "")}</Box>
      ) : (
        <Box sx={{ color: "red" }}>{capitalize(status ?? "")}</Box>
      ),
  },
];
